import React, {Component} from 'react';
import ReactToPrint from 'react-to-print';
import DateRangeFilter from '../components/DateRangeFilter';
import SalesTaxAuditReport from '../components/SalesTaxAuditReport';
import ReportHeaderState from '../components/ReportHeaderState';
import NoAccess from '../noAccess';
import {getTimeZoneOffsetDefault} from '../shared/dateTimeLists';
import {hasReportsAccess} from '../shared/authFunctions';
import FuseTheme from '../global/theme';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import {Card, CardText} from 'material-ui/Card';
import CircularProgress from 'material-ui/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';
import Avatar from 'material-ui/Avatar';
import Icon from 'material-ui/svg-icons/maps/local-atm';

export const fuseSalesTaxAuditReportsIcon = Icon;

const styles = {
    button: {color: FuseTheme.palette.primary3Color},
};

/**
 * Sales Tax Audit Reports class for retrieving and displaying summary
 *
 */
export class SalesTaxAuditReports extends Component {
    constructor(props) {
        super(props);
        const system = localStorage.getItem('system');
        const offsetDefault = getTimeZoneOffsetDefault();
        this.state = {
            errorMessage: null,
            location: {
                id: null,
                name: '',
                city: '',
                state: ''
            },
            selectedEndDate: null,
            selectedStartDate: null,
            selectedOffset: offsetDefault,
            summaryComplete: false,
            system: system
        };
    }

    /**
     * Convert Dates to visual display
     *
     * @param selectedStartDate
     * @param selectedEndDate
     * @return {string}
     */
    displaySelectedDates(selectedStartDate, selectedEndDate) {
        const options = {year: 'numeric', month: 'long', day: 'numeric'};
        let startDate = new Date(selectedStartDate + 'T00:00:00');
        let endDate = new Date(selectedEndDate + 'T00:00:00');
        let startDateStr = startDate.toLocaleDateString('en-US', options);
        let endDateStr = endDate.toLocaleDateString('en-US', options);

        return (
            'Date Range: ' + startDateStr + ' through ' + endDateStr
        )
    }

    /**
     * Handle event props from DateRangeFilter
     *
     * @param type
     * @param value
     */
    handleFilterSelect = (type, value) => {
        switch (type) {
            case 'start_date':
                // Set Start Date selection for reports summary component
                this.setState({selectedStartDate: value});
                break;
            case 'end_date':
                // Set End selection for reports summary component
                this.setState({selectedEndDate: value});
                break;
            case 'offset':
                // Set Time Zone Offset selection for reports summary component
                this.setState({selectedOffset: value});
                break;
            default:
                return
        }
    };

    /**
     * Handle event props for Sales Tax Audit Summary table completion
     *
     * @param isComplete
     */
    handleSummaryComplete = (isComplete) => {
        this.setState({
            summaryComplete: isComplete,
        });
    };

    handleReportError = (message) => {
        this.setState({
            errorMessage: message,
            summaryComplete: true,
        });
    };

    render() {
        const {
            errorMessage,
            selectedEndDate,
            selectedStartDate,
            selectedOffset,
            summaryComplete,
            system
        } = this.state;

        if (!hasReportsAccess()) return <NoAccess/>;

        const ListTitle = <span className="list-title hide-print">
            <Avatar icon={<Icon/>} className="avatar-title"/>Sales Tax Audit Reports</span>;

        const ListDescription = () => {
            return (
                <span className="list-description hide-print">
                    <p>A Sales Tax by Date Range Audit Report displays gross transactions and sales tax
                        collected for all Locations in multiple U.S. states for a specified date range.</p>
                    <p>Select a Date Range and Time Zone Offset to generate a Report:</p>
                </span>
            );
        };

        return (
            <div className="lists-container" ref={e => (this.printReportRef = e)}>
                <Card>
                    <ViewTitle title={ListTitle}/>
                    <CardText>
                        <ListDescription/>

                        {/* Report Filter (Start Date, End Date, Time Zone) */}
                        <DateRangeFilter
                            onSelectStartDate={this.handleFilterSelect}
                            onSelectEndDate={this.handleFilterSelect}
                            onSelectOffset={this.handleFilterSelect}
                        />

                        {/* Print Header */}
                        {selectedStartDate && selectedEndDate &&
                        <ReportHeaderState
                            reportType="Sales Tax Audit Report Summary"
                        />
                        }

                        {/* Sales Tax Audit Report Content */}
                        {selectedStartDate && selectedEndDate && selectedOffset &&
                        <div>

                            {/* Report Header, Loader, and messaging */}
                            <div className="list-header hide-print report-header">
                                <div className="btn-print-container report-header-button-container">
                                    <ReactToPrint
                                        trigger={() =>
                                            <RaisedButton
                                                primary
                                                type="button"
                                                label="Print Report"
                                                style={styles.button}
                                            />
                                        }
                                        content={() => this.printReportRef}
                                    />
                                </div>
                                <h2 className="report-header-title">Sales Tax Audit Report</h2>
                                <p>
                                    {this.displaySelectedDates(selectedStartDate, selectedEndDate)}
                                </p>
                            </div>

                            {!summaryComplete &&
                            <div className="loader-container">
                                <h4>Generating Report...</h4>
                                <CircularProgress
                                    size={24}
                                    thickness={2}
                                    className="loader"
                                />
                            </div>
                            }

                            {/* Summary Report */}
                            <SalesTaxAuditReport
                                startDate={selectedStartDate}
                                endDate={selectedEndDate}
                                offset={selectedOffset}
                                onSummaryComplete={this.handleSummaryComplete}
                                onError={this.handleReportError}
                                system={system}
                            />
                        </div>
                        }

                        {/* Error and Messaging */}
                        {errorMessage &&
                            <div className="error">
                                <p>{errorMessage}</p>
                            </div>
                        }
                    </CardText>
                </Card>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/Report/SalesTaxAuditReports.js